import type { ActivationId } from '@atlassian/jira-shared-types/src/general.tsx';
import { useTenantContext } from '../tenant-context/index.tsx';

export const useActivationId = (): ActivationId => {
	const tenantContext = useTenantContext();
	return tenantContext && tenantContext.activationId;
};
